import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { monthNames } from "../helpers/date";
import { getCrateCreditPreview } from "../helpers/processprintdata";
import DateRangePicker from "../common/DateRangePicker";
import { GETREQUEST } from "../helpers/ServiceRequest";
import { formatInvoiceNo } from "../helpers/common";

function AllCrateCredits() {
  let currentDate = new Date();
  var currentMonth = currentDate.getMonth() + 1;
  let currentDay = currentDate.getDate();
  if (currentDay < 10) currentDay = "0" + currentDay;
  if (currentMonth < 10) {
    currentMonth = "0" + currentMonth;
  }
  let date = currentDate.getFullYear() + "-" + currentMonth + "-" + currentDay;
  const [SearchCreditCode, setSearchCreditCode] = useState("");
  const [SearchCustomerCode, setSearchCustomerCode] = useState("");
  const [SearchCreditNoteRef, setCreditNoteRef] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortBy, setSortBy] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [credits, setCredits] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [totalItems, setTotalItems] = useState();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(25);
  const [currentPage, setCurrentPage] = useState();
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let PCURL =
        process.env.REACT_APP_API_URL + `/get-crate-credits?page=${page}&size=${size}`;
      let queryParams = [];

      if (SearchCreditCode) queryParams.push(`SearchCreditCode=${SearchCreditCode.toUpperCase()}`);
      if (SearchCustomerCode) queryParams.push(`SearchCustomerCode=${SearchCustomerCode}`);
      if (SearchCreditNoteRef) queryParams.push(`SearchCreditNoteRef=${SearchCreditNoteRef}`);
      if (startDate && endDate) queryParams.push(`startDate=${startDate}&endDate=${endDate}`);
      if (sortColumn && sortBy) queryParams.push(`sortColumn=${sortColumn}&sortBy=${sortBy}`);

      if (queryParams.length > 0) PCURL += `&${queryParams.join('&')}`;
      let response = await GETREQUEST(PCURL, user.jwtToken, false);
      if (response?.data) {
        setLoading(false);
        setCredits(response.data.data);
        setTotalPages(response.data.totalPages);
        setTotalItems(response.data.totalItems);
        setCurrentPage(response.data.currentPage);
      }
    }
    fetchData();
  }, [page, size, sortColumn, sortBy, SearchCreditCode, SearchCustomerCode, SearchCreditNoteRef, startDate, endDate]);

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight - 20 + "px");
  });

  const handleSort = (sortName) => {
    setSortColumn(sortName);
    if (sortBy == "")
      setSortBy("ASC")
    else if (sortBy == "ASC")
      setSortBy("DESC")
    else
      setSortBy("ASC")
  }

  const handleDateRange = (startDate, endDate) => {
    setStartDate(startDate ? startDate.format('YYYY/MM/DD') : null);
    setEndDate(endDate ? endDate.format('YYYY/MM/DD') : null);
  }

  const getStartPageIndex = () => {
    return page === 0 ? 1 : page * size + 1;
  };

  const getEndPageIndex = () => {
    if (page === 0) {
      return credits.length;
    }
    const endIndex = (page + 1) * size;
    return endIndex > totalItems ? totalItems : endIndex;
  };

  return (
    <React.Fragment>
      <Header />
      <main className="overflow-auto">
        <section className="p-4 table-listing">
          <div className="table-elements">
            <div className="paginations d-flex align-items-center p-2">
              <p className="fs-14 text-lite mb-1 me-2">
                Showing Results{" "}
                <span className="text-dark">{totalItems == 0 ? 0 : getStartPageIndex()}</span> -{" "}
                <span className="text-dark">{getEndPageIndex()}</span> of{" "}
                <span className="text-dark">{totalItems}</span>
              </p>
              <ul className="list-inline mb-1">
                {currentPage > 0 && (
                  <li className="list-inline-item">
                    <a style={{ cursor: "pointer" }} onClick={() => setPage(page - 1)}>
                      {" "}
                      <i className={`bi bi-chevron-left text-light`}></i>{" "}
                    </a>
                  </li>
                )}
                {totalPages > currentPage + 1 && (
                  <li className="list-inline-item">
                    <a style={{ cursor: "pointer" }} onClick={() => setPage(page + 1)}>
                      {" "}
                      <i className={`bi bi-chevron-right text-dark`}></i>{" "}
                    </a>
                  </li>
                )}
              </ul>
              <div style={{ marginLeft: "10px" }}>
                <select
                  className="form-select input-sm cme-10"
                  aria-label="Page size select example"
                  style={{ width: "100px" }}
                  value={size}
                  onChange={(e) => { setSize(e.target.value); setPage(0) }}
                >
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>
          </div>
          <div className="card border-bottom-0 w-100">
            <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap">
              <h1 className="title-semibold fs-24 mb-xl-0 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                All Crate Credits
              </h1>
              <div className="filter-elements d-flex align-items-center">
                <div className="custom-group flex-nowrap align-items-center">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Filter by:
                  </label>
                  <DateRangePicker onSelected={handleDateRange} />
                </div>
              </div>
            </div>
            <div className="card-body p-0 border-bottom">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="width-lg-13 width-sm-auto  text-start "
                      >
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('CreditCode')}>Credit No.</span>
                          {sortColumn == "CreditCode" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Credit No"
                            onChange={(e) => setSearchCreditCode(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-8 width-sm-auto ps-3">

                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('CNDate')}>Credit Date</span>
                          {sortColumn == "CreditDate" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            style={{ visibility: "hidden" }}
                          />
                        </div>
                      </th>
                      <th
                        scope="col"
                        className="width-lg-14 width-sm-auto"
                      >
                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('CustomerID')}>Customer Code</span>
                          {sortColumn == "CustomerCode" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Cust. Code"
                            onChange={(e) => setSearchCustomerCode(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-12 width-sm-auto">

                        <div>
                          <span style={{ cursor: "pointer" }} onClick={() => handleSort('CNReference')}>Credit Note Ref</span>
                          {sortColumn == "CreditNoteRef" &&
                            <span> <i className={`bi ${sortBy == "ASC" ? "bi-arrow-down-short" : "bi-arrow-up-short"}`}></i></span>
                          }
                        </div>
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            placeholder="Search by Ref NO."
                            onChange={(e) => setCreditNoteRef(e.target.value)}
                          />
                        </div>
                      </th>
                      <th scope="col" className="width-lg-5 width-sm-auto">
                        Action
                        <div className="w-35 p-1">
                          <input
                            type="text"
                            className="form-control input-sm search"
                            style={{ visibility: "hidden" }}
                          />
                        </div>
                      </th>

                    </tr>
                  </thead>
                  <tbody className="position-relative">
                    {loading && (
                      <tr className="position-absolute w-100 ">
                        <td className="bg-white w-100 d-flex justify-content-center align-items-center p-1 border-0">
                          <div className="overlay">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {credits.length == 0 && (
                      <tr>
                        <td colSpan={6} className="text-center">
                          No Record Found
                        </td>
                      </tr>
                    )}
                    {credits.map((credit, index) => {
                      let date = new Date(credit.CNDate);
                      return (
                        <tr key={index}>
                          <td>{formatInvoiceNo(credit.CNID, "CCR")}</td>
                          <td className="ps-3">{date.getDate()} {monthNames[date.getMonth()]} {date.getFullYear()}</td>
                          <td>{credit.tblCustomer.CustomerCode}</td>
                          <td align="center">{credit.CNReference}</td>
                          <td className="d-flex gap-2">
                            <Link
                              to={`/view-edit-crate-credit/${credit.CNID}`}
                              className="btn btn-outline-lite btn-xs d-inline-flex align-items-center text-dark"
                            >
                              Edit
                            </Link>
                            <button
                              onClick={() => getCrateCreditPreview(user, credit.CNID)}
                              type="button"
                              className="btn btn-primary btn-xs d-inline-flex align-items-center text-white"
                            >
                              Preview
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                    <tr></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
export default AllCrateCredits;
